import React from 'react';
import styled from 'styled-components';

import Header from '~/components/Header';
import Footer from '~/components/Footer';
import Visualisation from '~/components/Visualisation';
import Infobox from '~/components/Infobox';

const AppWrapper = styled.div`
  height: 100%;
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  padding: 0 15px;
`;

function App() {
  return (
    <>
      <AppWrapper>
        <Header />
        <Visualisation />
        <Footer />
      </AppWrapper>
      <Infobox />
    </>
  );
}

export default App;
